import React, { useCallback, useEffect, useMemo, useState, useContext } from "react";
import "./index.less";

import {
  ChatMessage,
  ChatMessageType,
  Employee,
  MessageEmitBody,
  Session,
  MessageStatus
} from "@/types/chat";
import SearchInput from "../Input";
import { useTranslation } from "react-i18next";
import DefaultPage from "@/components/DefaultPage";
import { CompDataLoadState, DefaultPageType } from "@/models";
import InfiniteScroll from "react-infinite-scroller";
import debounce from "lodash/debounce";
import ImService from "@/server/ImService";
import { Checkbox, List } from "antd";
import DownloadFile from "@/baseComponents/Chat/message/File/History";
import { getMessageSendType } from "@/utils/chat/message";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import Loading from "@/components/Loading";
import Forwarding from "../../message/Forwarding";
import { getFileOperateAuthority } from "@/utils/tools";
import ChatContext from "@/components/chat/context";
export interface ISearchFileProps {
  currentSession: Session;
  currentEmployee: Employee;
  jumpTo?: (mid: number) => void;
  dataSource?: any[];
  isLoading?: boolean;
  hasMore?: boolean;
  loadMore?: () => void;
  historySearchOpen?: boolean;
  handleJump?: (message: any) => void;
}

function SearchFile(props: ISearchFileProps) {
  const {
    currentSession,
    jumpTo,
    currentEmployee,
    dataSource = [],
    isLoading = false,
    loadMore,
    hasMore = true,
    historySearchOpen,
    handleJump
  } = props;
  const [searchKey, setSearchKey] = useState("");
  const [selectedMsgs, setSelectedMsgs] = useState<MessageEmitBody[]>([]);
  const { appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const { currentFileControl } = React.useContext(ChatContext);
  const [expiredMids, setExpiredMids] = useState<number[]>([]);

  useEffect(() => {
    if (!historySearchOpen) {
      setSelectedMsgs([]);
    }
  }, [historySearchOpen]);
  // const isGovEnv = ["mebj", "jgswy", "mebjJZB"].includes(appRuntimeEnv.runtimeConfig.key);
  const handleInfiniteOnLoad = useCallback(() => {
    loadMore?.();
  }, [loadMore]);

  // 是否有下载权限
  const canDownloadAuth = useCallback(
    (message: any) => {
      const auth = getFileOperateAuthority(
        "download",
        currentFileControl || [],
        message?.fileTag || 0
      );
      return auth;
    },
    [currentFileControl]
  );
  const handleChange = (e: any, message: any) => {
    // console.log('e', e, 'message', message);
    let temp = [...selectedMsgs];
    const idx = selectedMsgs.findIndex((item) => item.mid === message.mid);
    if (idx < 0) {
      temp.splice(0, 0, message);
      // console.log('addArr', temp);
      temp = temp.sort((item1, item2) => item1.timestamp - item2.timestamp);
      setSelectedMsgs(temp);
      return;
    } else {
      temp.splice(idx, 1);
      // console.log('deleteArr', temp);
      temp = temp.sort((item1, item2) => item1.timestamp - item2.timestamp);
      setSelectedMsgs(temp);
      return;
    }
  };

  const getCheckedStatus = (message: any) => {
    return selectedMsgs.findIndex((item) => item.mid === message.mid) < 0;
  };

  const clearMsgs = () => {
    setSelectedMsgs([]);
  };

  const handleExpiredFileClick = (mid: number) => {
    setExpiredMids((prev) => [...prev, mid]);
  };

  // const isEgovFile = useMemo(() => {
  //   return message.type === ChatMessageType.EGOV_FILE || message.kind === ChatMessageType.EGOV_FILE;
  // }, [message]);

  return (
    <div className="search-history search-file">
      <div className="search-history-result">
        <div className="message-list">
          {dataSource?.length === 0 && (
            <div className="illustration">
              <DefaultPage
                dataType={CompDataLoadState.NODATA}
                pageType={DefaultPageType.SEARCH_HISTORY}
              />
            </div>
          )}
          {(dataSource?.length || 0) > 0 && (
            <InfiniteScroll
              initialLoad={false}
              pageStart={0}
              loadMore={handleInfiniteOnLoad}
              hasMore={!isLoading && hasMore}
              useWindow={false}
            >
              <List
                dataSource={dataSource}
                loading={
                  isLoading
                    ? {
                        indicator: (
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              minHeight: "200px",
                              left: 0
                            }}
                          >
                            <Loading />
                          </div>
                        )
                      }
                    : false
                }
                renderItem={(item) => (
                  <div
                    className={`message-item ${
                      currentSession?.isSecret ? "message-item_normal" : ""
                    }`}
                  >
                    {!currentSession?.isSecret && (
                      <div className={`checkbox-wrapper ${selectedMsgs.length > 0 ? "show" : ""}`}>
                        <Checkbox
                          checked={!getCheckedStatus(item)}
                          onChange={(e) => handleChange(e, item)}
                          disabled={
                            item.statusType === MessageStatus.EXPIRED ||
                            expiredMids.includes(item.mid) ||
                            !canDownloadAuth(item)
                          }
                        />
                      </div>
                    )}
                    <DownloadFile
                      message={item}
                      sendType={getMessageSendType(
                        (item as unknown) as ChatMessage,
                        currentEmployee,
                        currentSession
                      )}
                      handleExpiredFileClick={handleExpiredFileClick}
                      searchKey={searchKey}
                      jumpTo={() => handleJump?.(item)}
                      expiredMids={expiredMids}
                    />
                  </div>
                )}
              />
            </InfiniteScroll>
          )}
        </div>
      </div>
      {!currentSession?.isSecret && selectedMsgs?.length ? (
        <Forwarding
          groupMsgs={selectedMsgs}
          clearSelectedMsgs={clearMsgs}
          isGroupFileForward={true}
        />
      ) : null}
    </div>
  );
}

export default SearchFile;
